import React from 'react';
import { Row, Col, Typography, Button } from 'antd';
import { Field as FField } from 'react-final-form';
import { FieldArray as FFieldArray } from 'react-final-form-arrays';
import { InputControl } from '../../fields/Fields';
import { required } from '../../../utils/validations';

const { Title, Paragraph } = Typography;

export const FreeResponseRubricFields = ({ name }) => (
  <>
    <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]} style={{ marginTop: 8, width: '100%' }}>
      <Col span={24}>
        <Title level={5} style={{ fontWeight: 'bolder' }}>
          Required key details
        </Title>
        <Paragraph type='secondary' style={{ marginBottom: 12 }}>
          Marked correct only if the student covers each idea (in their own words) and avoids factual mistakes.
        </Paragraph>
        <FFieldArray name={`${name}.freeResponseKeyDetails`}>
          {({ fields }) => (
            <>
              {fields.map((fieldName, idx) => (
                <Row key={fieldName} gutter={8} align='middle' style={{ marginBottom: 12 }}>
                  <Col flex='auto'>
                    <FField
                      name={fieldName}
                      component={InputControl}
                      placeholder={`Key detail ${idx + 1}`}
                      validate={required}
                    />
                  </Col>
                  <Col>
                    <Button
                      type='link'
                      danger
                      disabled={fields.length <= 1}
                      onClick={() => fields.remove(idx)}
                    >
                      Remove
                    </Button>
                  </Col>
                </Row>
              ))}
              <Button type='dashed' onClick={() => fields.push('')}>
                + Add key detail
              </Button>
            </>
          )}
        </FFieldArray>
      </Col>
    </Row>
    <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]} style={{ marginTop: 24, width: '100%' }}>
      <Col span={24}>
        <Title level={5} style={{ fontWeight: 'bolder' }}>
          Inaccuracies to flag (optional)
        </Title>
        <Paragraph type='secondary' style={{ marginBottom: 12 }}>
          If the student states any of these incorrect claims, the answer is marked wrong.
        </Paragraph>
        <FFieldArray name={`${name}.freeResponseInaccuracies`}>
          {({ fields }) => (
            <>
              {fields.map((fieldName, idx) => (
                <Row key={fieldName} gutter={8} align='middle' style={{ marginBottom: 12 }}>
                  <Col flex='auto'>
                    <FField
                      name={fieldName}
                      component={InputControl}
                      placeholder='Incorrect claim to watch for'
                    />
                  </Col>
                  <Col>
                    <Button type='link' danger onClick={() => fields.remove(idx)}>
                      Remove
                    </Button>
                  </Col>
                </Row>
              ))}
              <Button type='dashed' onClick={() => fields.push('')}>
                + Add inaccuracy
              </Button>
            </>
          )}
        </FFieldArray>
      </Col>
    </Row>
  </>
);
